export enum GameKind {
  FULL_GAME_KIND = 'FULL_GAME_KIND',
  FOCUS_GAME_KIND = 'FOCUS_GAME_KIND',
  MONOTONITY_GAME_KIND = 'MONOTONITY_GAME_KIND'
}
